<!--板块异动-->
<template>
  <div class="mod">
    <h2>
      <i>3</i>板块异动
      <span class="icon-help" v-on:click="helpDec">?</span>
    </h2>
    <p
      class="help-pop"
      style="display: block"
      v-show="isHelp"
    >根据AI人工智能算法研究，在盘中由大数据识别模型实时抓取的资金大进大出、股价振幅加大；或者突然出现资金大量流出，股价上升势头却依然强劲或略有减缓；或者一段时间内资金大量流入，但股价却变化不大的几种情况，可以根据板块异动的变化快速了解风口切换方向。</p>

    <!-- <div class="chart-wrap" id="abc-echart-containers"></div> -->

    <ul class="time-line load" :class="[text]" v-html="datachars"></ul>
    <p class="load-more" @click="loadmore()">
      <a href="###" class="all" :class="[up]">{{more}}</a>
    </p>
  </div>
</template>
<script>
import { queryBkydInfo } from "@/api/microService";
export default {
  data() {
    return {
      datachars: null,
      xdata: null,
      ydata: null,
      fengzhi: null,
      topheigh:null,
      guzhi: null,
      bfb: null,
      basic: null,
      miaodian: null,
      tt: "",
      more: "展开",
      text: "fold",
      up: "",
      isHelp: false
    };
  },
  methods: {
    helpDec() {
      this.isHelp = !this.isHelp;
    },
    loadmore() {
      if (this.more == "展开") {
        this.more = "收起";
        this.text = "";
        this.up = "up";
        this.topheigh = this.getScrollTop();
        console.log( this.getScrollTop());
      } else {
        this.more = "展开";
        this.text = "fold";
        this.up = "";
        //document.body.scrollTop = this.topheigh;
        this.__getPageScrollY(this.topheigh);
      }
    },

     __getPageScrollY(top) {
 
        if (top || Number(top) == 0) { //设置垂直滚动值
            if (self.pageYOffset) {
                self.pageYOffset = Number(top);
            }
            if (document.documentElement && document.documentElement.scrollTop) { // Explorer 6 Strict
                document.documentElement.scrollTop = Number(top);
            }
            if (document.body) {// all other Explorers
                document.body.scrollTop = Number(top);
            }
            return true;
        } else { //获取垂直滚动值
            var yScroll;
            if (self.pageYOffset) {
                yScroll = self.pageYOffset;
            } else if (document.documentElement && document.documentElement.scrollTop) { // Explorer 6 Strict
                yScroll = document.documentElement.scrollTop;
            } else if (document.body) {// all other Explorers
                yScroll = document.body.scrollTop;
            }
            return yScroll;
        }
 
    },

 getScrollTop() {  
        var scrollPos;  
        if (window.pageYOffset) {  
        scrollPos = window.pageYOffset; }  
        else if (document.compatMode && document.compatMode != 'BackCompat')  
        { scrollPos = document.documentElement.scrollTop; }  
        else if (document.body) { scrollPos = document.body.scrollTop; }   
        return scrollPos;   
},
    getFirstMsg() {
      let self = this;
      dzhyun.query(
        "/quote/min",
        {
          obj: "SH000001"
        },
        resStockList => {
          var arr = [];
          var ayy = [];
          var max = 0;
          var min = 0;
          var basic = null;
          var guzhi = null;
          var fengzhi = null;
          var xdata = [];
        
          for (var i = 0; i < resStockList[0].Data.length; i++) {
            ayy.push(resStockList[0].Data[i].ChengJiaoJia);
            if (resStockList[0].Data[i].ChengJiaoJia > max) {
              max = resStockList[0].Data[i].ChengJiaoJia;
            }
            if (i == 1) {
              min = resStockList[0].Data[i].ChengJiaoJia;
              basic = resStockList[0].Data[i].ChengJiaoJia;
              this.basic = resStockList[0].Data[i].ChengJiaoJia;
            } else {
              if (resStockList[0].Data[i].ChengJiaoJia < min) {
                min = resStockList[0].Data[i].ChengJiaoJia;
              }
            }
            xdata.push(resStockList[0].Data[i].ShiJian);
          }
          this.ydata = ayy;
          var yydata = [];
          for (var i = 0; i < 256; i++) {
            arr.push(i);
          }
          //this.xdata = arr;
          this.xdata = xdata;
          var data = this.getDetail(max, min, basic);
          this.fengzhi = data[0];
          this.guzhi = data[1];
          this.bfb = data[2];
          this.getData(this.basic);
        }
      );
    },
    getDetail(max, min, basic) {
      var l1 = (Math.abs(basic - max) / basic) * 100;
      var l2 = (Math.abs(basic - min) / basic) * 100;

      var l3 = null;
      if (l1 > l2) {
        l3 = l1;
      } else if (l1 <= l2) {
        l3 = l2;
      }

      return [
        (((Math.ceil(l3 / 0.5) * 0.5) / 100 + 1) * basic).toFixed(2),
        ((1 - (Math.ceil(l3 / 0.5) * 0.5) / 100) * basic).toFixed(2),
        Math.ceil(l3 / 0.5) * 0.5
      ];
    },
    fmtStr(obj){
      var str = "'VIEWSTOCK?DATATYPE=DAY&LABEL="+obj+"&PAGE=分时走势;VIEWINDI?NUMPIC=3&INDI1=MA&INDI2=VOL;INDI3=SVNS'";
      return str;
    },
    getData: function(val) {
      var self = this;
      // 调用微信服务测试
      dzhMicroToken.then(
        response => {
          // 执行成功的回调函数
          if (response.resCode === "000000") {
          console.log(response);
            var data = {
              merId: "MER201805260001",
              busiCode: "3001",
              token: response.resData.token
            };
            queryBkydInfo(data).then(response => {
              var html = "";
              console.log(response);
              response.data.data.forEach(items => {
                if (items.type == 8 || items.type == 6 || items.type == 2) {
                  html +=
                    '<li class="item-up"><span class="time">' +
                    items.time +
                    "</span><p>" +
                    items.name +
                    '<strong class="time-line-tag tag-red">快速拉升</strong></p><div class="time-line-stocks">';
                } else if (items.type == 9 || items.type == 7 || items.type == 3) {
                  html +=
                    '<li class="item-down"><span class="time">' +
                    items.time +
                    "</span><p>" +
                    items.name +
                    '<strong class="time-line-tag tag-green">快速下跌</strong></p><div class="time-line-stocks">';
                } else if (items.type == 4) {
                  html +=
                    '<li class="item-down"><span class="time">' +
                    items.time +
                    "</span><p>" +
                    items.name +
                    '<strong class="time-line-tag tag-red">高开</strong></p><div class="time-line-stocks">';
                } else if (items.type == 5) {
                  html +=
                    '<li class="item-down"><span class="time">' +
                    items.time +
                    "</span><p>" +
                    items.name +
                    '<strong class="time-line-tag tag-green">低开</strong></p><div class="time-line-stocks">';
                } else if (items.type == 16) {
                  html +=
                    '<li class="item-down"><span class="time">' +
                    items.time +
                    "</span><p>" +
                    items.name +
                    '<strong class="time-line-tag tag-red">尾盘异动</strong></p><div class="time-line-stocks">';
                } else {
                  html +=
                    '<li class="item-down"><span class="time">' +
                    items.time +
                    "</span><p>" +
                    items.name +
                    '</p><div class="time-line-stocks">';
                }
                var str = "";
                items.stks.forEach(item => {
                  var classstr = '';  //兼容长股票名称 6-7个字符 font-m  8个以上 font-s

                  if(item.snm.length>7){
                    classstr='font-s';
                  }else if(item.snm.length<=7 && item.snm.length >5){
                    classstr='font-m';
                  }else{
                    classstr='';
                  }

                  str +='<div class="'+classstr+'"><a href="javascript:void(0);" onclick="window.external.addcommand('+self.fmtStr(item.sc)+')">' +
                    item.snm +
                    "</a><span class='"+ this.getColor(item.schg) + "'>" +
                    item.schg +
                    "%</span></div>";
                });
                html += str;
                html += "</div></li>";
              });
              this.datachars = html;
              var diandian = [];
         
              for (var i = 0; i < response.data.chartsData.length; i++) {
                var map = [];
                if (response.data.chartsData[i].chg > 0) {
                  map["value"] = response.data.chartsData[i].name;
                  if (response.data.chartsData[i].time.split(":")[0] < 12) {
                    // map["xAxis"] =
                    //   parseInt(
                    //     response.data.chartsData[i].time.split(":")[0] - 9
                    //   ) *
                    //     60 +
                    //   parseInt(response.data.chartsData[i].time.split(":")[1]);
                    var myDate = new Date(); //获取当前日(1-31)
                    //获取当前年份(2位)

                    map["xAxis"] =
                      Date.parse(
                        myDate.getFullYear() +
                          "-" +
                          myDate.getMonth() +
                          "-" +
                          myDate.getDate() +
                          ":" +
                          response.data.chartsData[i].time
                      ) / 1000;
                  } else {
                    // map["xAxis"] =
                    //   parseInt(
                    //     120 +
                    //       (response.data.chartsData[i].time.split(":")[0] -
                    //         13) *
                    //         60
                    //   ) +
                    //   parseInt(response.data.chartsData[i].time.split(":")[1]);
                    map["xAxis"] =
                      Date.parse(
                        myDate.getFullYear() +
                          "-" +
                          myDate.getMonth() +
                          "-" +
                          myDate.getDate() +
                          ":" +
                          response.data.chartsData[i].time
                      ) / 1000;
                  }
                  map["yAxis"] = (
                    this.basic *
                    (1 + response.data.chartsData[i].chg / 100)
                  ).toFixed(2);
                  diandian.push(map);
                }
              }
              var str = "[";
              for (var index = 0; index < diandian.length; index++) {
                if (index < diandian.length - 1) {
                  str +=
                    '{"value":"' +
                    diandian[index].value +
                    '","xAxis":"' +
                    diandian[index].xAxis +
                    '","yAxis":' +
                    diandian[index].yAxis +
                    "},";
                } else {
                  str +=
                    '{"value":"' +
                    diandian[index].value +
                    '","xAxis":"' +
                    diandian[index].xAxis +
                    '","yAxis":' +
                    diandian[index].yAxis +
                    "}]";
                }
              }
              this.miaodian = str;
            
              this.miaodian = JSON.parse(this.miaodian);
             
            
              this.myChart();
            });
          }
        },
        error => {
          // 执行失败的回调函数
          console.log(error);
        }
      );
    },

    getColor:function(num){
      if(num && num !== 0){
        if(num > 0){
          return "span-red"
        }else if(num < 0){
          return "span-green"
        }
      }else{
        return "span-block"
      }
    },
    RiQi(sj) {
      var now = new Date(sj * 1000);
      var hour = now.getHours();
      var minute = now.getMinutes();
      return hour + ":" + minute;
    },
    myChart: function() {
      self = this;
      // 基于准备好的dom，初始化echarts实例
      var aechart = echarts.init(
        document.getElementById("abc-echart-containers"),
        "white"
      );
      // 绘制图表
      // 指定图表的配置项和数据
 var option = {
    title: {
        text: '未来一周气温变化',
        subtext: '纯属虚构'
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data:['最高气温','最低气温']
    },
    toolbox: {
        show: true,
        feature: {
            dataZoom: {
                yAxisIndex: 'none'
            },
            dataView: {readOnly: false},
            magicType: {type: ['line', 'bar']},
            restore: {},
            saveAsImage: {}
        }
    },
    xAxis:  {
        type: 'category',
        boundaryGap: false,
        data: ['周一','周二','周三','周四','周五','周六','周日']
    },
    yAxis: {
        type: 'value',
        axisLabel: {
            formatter: '{value} °C'
        }
    },
    series: [
        {
            name:'异动板块',
            type:'line',
            data:[11, 11, 14, 13, 12, 13, 10],
            markPoint: {
                symbol: "roundRect",
                symbolKeepAspect: true,
                symbolOffset: [0, "-80%"],
                symbolSize: [60, 25],
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'},
                     { value: '人工智能', xAxis: 1, yAxis: 11},
                     { value: '大智慧', xAxis: 3, yAxis: 13}
                ]
            }
            
        }
       
    ]
};

      // var option = {
      //   //backgroundColor: "#FFFFFF",
      //   tooltip: {
      //     trigger: "axis"
      //   },
      //   xAxis: {
      //     //show: false,
      //     type: "category",
      //     data: this.xdata,
      //     name: "-" + this.bfb + "%", //绿的百分比
      //     nameTextStyle: {
      //       color: "green"
      //     },
      //     nameLocation: "end",
      //     showMaxLabel: true,
      //     axisLabel: {
      //       formatter: val => {
      //         return this.RiQi(val);
      //       }
      //     }
      //   },
      //   color: ["#79CDCD"],
      //   lineStyle: {
      //     color: "#5CACEE"
      //   },

      //   yAxis: {
      //     type: "value",
      //     max: this.fengzhi,
      //     min: this.guzhi,
      //     interval: ((this.fengzhi - this.guzhi) / 2).toFixed(2),
      //     name: this.bfb + "%", //红的百分比
      //     nameTextStyle: {
      //       padding: [0, 0, 0, 1630],
      //       color: "red"
      //     }
      //   },
      //   series: [
      //     {
      //       data: this.ydata,
      //       type: "line",
      //       areaStyle: {},
      //       symbol: "none",
      //       type: "line",
      //       markPoint: {
      //         symbol: "rect",
      //         symbolKeepAspect: true,
      //         symbolOffset: [0, "90%"],
      //         symbolSize: [50, 15],
      //         itemStyle: { color: "red", shadowOffsetY: "300" },
      //         data: this.miaodian
             
      //       }
      //     }
      //   ]
      // };

      aechart.setOption(option);
    }
  },
  mounted() {},
  created() {
    this.getFirstMsg();
   
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/home/components/bkyd.vue